import * as React from 'react';

import { cn } from './lib/utils';

// Layout primitives for pages that need a top-level flex column where some
// rows are chrome (toolbars, headers, summary strips) and one region fills
// the remaining vertical space — typically an AG Grid or a virtualised list
// that measures itself against a parent with an explicit, non-zero height.
//
// The three pieces are deliberately small so misuse is limited to an import
// typo. They encapsulate the canonical `flex min-h-0 flex-1 flex-col` /
// `shrink-0` / `min-h-0 flex-1` triad that breaks in subtle ways when
// hand-rolled (parent height collapses, chrome squeezes the body, grids
// mount into a 0-height container).

function FullHeightStack({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="full-height-stack"
      className={cn('flex min-h-0 flex-1 flex-col', className)}
      {...props}
    />
  );
}

function FullHeightChrome({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="full-height-chrome" className={cn('shrink-0', className)} {...props} />;
}

function FullHeightFill({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div data-slot="full-height-fill" className={cn('min-h-0 flex-1', className)} {...props} />
  );
}

export { FullHeightStack, FullHeightChrome, FullHeightFill };
